export type EventTypes = [
    'click',
    // 'custom',
    'change',
    'input',
    'keydown',
    // 'keyup',
    'keypress',
    'focus',
    'blur',
    'beforeinput',
    'submit',
    'select',
];

/**
 * Note: adding listeners to some inputs have negative side affects on the omega components.
 * We'll need to look into this further, it'd be nice to have all these events available
 */
export const Events = [
    // 'click',
    // 'custom',
    'input',
    'change',
    // 'keydown',
    // 'keyup',
    // 'keypress',
    // 'focus',
    'blur',
    // 'beforeinput',
    // 'submit',
    // 'select',
];
